import { css } from '@emotion/css';

export const checkboxStyles = css`
  svg {
    width: 2rem;
    height: 2rem;
  }
`;
